<template>
  <div class="user-notice-view">
    <section class="module">
      <div class="m-body">
        <el-tabs v-model="type">
          <el-tab-pane name="all" label="全部"></el-tab-pane>
          <el-tab-pane name="unread" label="未读"></el-tab-pane>
        </el-tabs>
        <el-table :data="list" stripe ref="noticeTable" @expand-change="expandChange">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div>{{scope.row.content}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="通知时间" prop="time" width="200">
            <template slot-scope="scope">
              <span>{{scope.row.time.replace('T', ' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="标题" prop="sub">
            <template slot-scope="scope">
              <span :class="'pointer notice-sub' + (scope.row.read ? '' : ' unread')" @click="expandRow(scope.row)">{{scope.row.sub}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="hasMore" class="mt20 tc">
          <el-button type="primary" plain size="mini" @click="getMore">查看更多</el-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'user-notice',
  data () {
    let type = this.$store.getters.unReadNoticeCount ? 'unread' : 'all'
    return {
      type,
      list: [],
      hasMore: false,
      pageIndex: 1,
      pageSize: 10
    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '个人中心', path: '/user/center' }, { name: '消息通知' }])
    this.getData().then((data) => {
      this.$nextTick(() => {
        this.list = data
        this.hasMore = data && data.length >= this.pageSize
      })
    })
  },
  methods: {
    getData () {
      this.$store.dispatch('setLoading')
      return new Promise((resolve, reject) => {
        this.$http.get(`message/${this.type}?pagesize=${this.pageSize}&pageindex=${this.pageIndex}`)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            this.$message.error('获取通知失败')
            reject(error)
          })
          .then(() => {
            this.$store.dispatch('setLoading', false)
          })
      })
    },
    typeChange () {
      this.pageIndex = 1
      this.getData().then((data) => {
        this.list = data
        this.hasMore = data && data.length >= this.pageSize
      })
      .catch(() => {
        this.list = []
        this.hasMore = false
      })
    },
    getMore () {
      this.pageIndex++
      this.getData().then((data) => {
        this.list.concat(data)
        this.hasMore = data && data.length >= this.pageSize
      })
    },
    expandChange (row) {
      if (!row.read) {
        row.read = true
        this.$store.dispatch('readOneNotice')
        // 请求阅读消息接口
        this.$http.post('message/markread', [row.id])
      }
    },
    expandRow (row) {
      this.$refs.noticeTable.toggleRowExpansion(row)
    }
  },
  watch: {
    'type': function () {
      this.typeChange()
    }
  }
}
</script>

<style lang="scss">
.user-notice-view {
  .el-tabs__item {
    width: 100px;
    text-align: center;
  }
  .notice-sub {
    &:hover {
      text-decoration: underline;
    }
    &.unread {
      font-weight: bold;
      &::before {
        content: "";
        margin: 0 2px 0 -8px;
        background: #f56c6c;
        display: inline-block;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/notice.vue